export default __webpack_public_path__ + "static/media/code-fill.d8822ebc.svg";